module.exports = __webpack_public_path__ + "img/javaMobile2.1d354270.jpg";